export const ADD_ITEM_IN_CART = "ADD_ITEM_IN_CART";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const UPDATE_QUANTITY_CART_ITEM = "UPDATE_QUANTITY_CART_ITEM";
export const CLEAR_CART = "CLEAR_CART";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const CHANGE_MODE = "CHANGE_MODE";

export const FETCH_BRANDS = "FETCH_BRANDS";
export const FETCH_TYPES = "FETCH_TYPES";
export const FETCH_SUPPLIERS = "FETCH_SUPPLIERS";
export const FETCH_SUPPLIES = "FETCH_SUPPLIES";
export const FETCH_ORDERS = "FETCH_ORDERS";
export const FETCH_CLIENTS = "FETCH_CLIENTS";
export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FETCH_BANERS = "FETCH_BANERS";
export const FETCH_USER = "FETCH_USER";
export const SET_LOADER = "SET_LOADER";
